
      export default `query ($name: String!, $orderBy: CollectionOrderBy) {
  collection(name: $name, orderBy: $orderBy) {
    id
    label
    title
    route
    layout
    tableOfContents {
      label
      route
    }
  }
}
`;
    